// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CaseTemplateRow_edit_popup__sCRdE {
  z-index: 8000;
}

.CaseTemplateRow_edit_popup_container__LRFst {
  position: fixed !important;
  left: 210px;
  top: 91px;
  width: 290px;
}

/* email row */
.CaseTemplateRow_email_row_root__0\\+mf4 {
  margin-top: 10px;
  display: flex;
  color: var(--color-theme-10);
  height: 45px;
  cursor: pointer;
  align-items: center;
  padding: 5px;

  background-color: var(--color-bg-caselist-item);
  border: 2px solid var(--color-bg-caselist-item);
}

.CaseTemplateRow_email_row_root__0\\+mf4:hover {
  background-color: var(--color-bg-caselist-item-hover);
  border: 2px solid var(--color-bg-caselist-item-hover);
}

.CaseTemplateRow_root_inactive__2k8-9 {
  background-color: var(--color-bg-caselist-item);
  border: 1px solid var(--color-theme-bright-gray);
}

.CaseTemplateRow_root_active__2e-Dj {
  background-color: var(--color-bg-caselist-item-hover);
  border: 2px solid var(--color-bg-caselist-item-hover);
  box-shadow: 2px 2px 3px var(--color-theme-cloud);
}

.CaseTemplateRow_email_flow_input__bn-8A {
  background-color: var(--color-bg-caselist-item);
  outline: none;
  border: none;
  color: var(--color-font-10);
  font-weight: bold;
  font-size: 16px;
}

.CaseTemplateRow_account_tree_icon__rStr6 {
  margin: 0px 10px;
}

.CaseTemplateRow_edit_icon_container__lMPMO {
  display: flex;
  justify-content: flex-end;
}

.CaseTemplateRow_edit_icon__pWFYo {
  padding: 0px 10px;
}

.CaseTemplateRow_edit_icon__pWFYo:hover {
  color: var(--color-font-10);
}

.CaseTemplateRow_input_container__e2S7s {
  width: 65%;
  margin-left: 30px;
}

.CaseTemplateRow_flow_list_item__RMBNm {
  padding: 0px !important;
}

.CaseTemplateRow_email_row_root__0\\+mf4:hover .CaseTemplateRow_edit_icon__pWFYo {
  color: var(--color-font-10);
}

/* submenu */
.CaseTemplateRow_template_row_root__7zQin {
  display: flex;
  color: var(--color-theme-10);

  height: 45px;
  cursor: pointer;
  align-items: center;
  padding: 5px;

  background-color: var(--color-bg-caselist-item);
  border: 2px solid var(--color-bg-caselist-item);
}

.CaseTemplateRow_template_row_root__7zQin:hover {
  background-color: var(--color-bg-caselist-item-hover);
  border: 2px solid var(--color-bg-caselist-item-hover);
  color: var(--color-font-10) !important;
}

.CaseTemplateRow_template_row_root_selected__H6DlO {
  display: flex;
  color: var(--color-theme-10);
  height: 45px;
  cursor: pointer;
  align-items: center;
  padding: 5px;
  background-color: var(--color-bg-caselist-item-selected);
  border: 2px solid var(--color-bg-caselist-item-selected);
}

.CaseTemplateRow_status_item__kb14D {
  height: 45px;
  font-size: 12px;
}

.CaseTemplateRow_status_icon__s-EBn {
  margin: 0px 10px 0px 15px;
}

.CaseTemplateRow_status_icon__s-EBn svg {
  font-size: 20px !important;
}

.CaseTemplateRow_status_title__yzaGe {
  font-size: 13px;
  display: inline-block;
  height: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.CaseTemplateRow_delete_template__N70Mk {
  width: 100%;
  display: none;
  justify-content: flex-end;
  color: var(--color-theme-cloud);
}

.CaseTemplateRow_add_template_title__dzN5p {
  color: var(--color-theme-silver);
}

.CaseTemplateRow_add_template_icon__zCwqA {
  color: var(--color-theme-silver);
}

.CaseTemplateRow_template_row_root__7zQin:hover .CaseTemplateRow_add_template_icon__zCwqA {
  color: var(--color-font-10);
}

.CaseTemplateRow_template_row_root__7zQin:hover .CaseTemplateRow_add_template_title__dzN5p {
  color: var(--color-font-10);
}

.CaseTemplateRow_template_row_root__7zQin:hover .CaseTemplateRow_delete_template__N70Mk {
  display: flex;
  color: var(--color-theme-cloud);
}

.CaseTemplateRow_template_row_root_selected__H6DlO .CaseTemplateRow_delete_template__N70Mk {
  display: flex;
  color: var(--color-theme-cloud);
}

.CaseTemplateRow_delete_icon__P-wcI:hover {
  color: var(--color-theme-blue);
}

.CaseTemplateRow_deletionPopupText__gfHS4 {
  padding: 5px;
}

.CaseTemplateRow_button_confirm__0zlLH {
  font-weight: bold !important;
  width: 100px;
  margin-left: 15px !important;
  color: var(--color-theme-red) !important;
  border: 1px solid var(--color-theme-red) !important;
  color: var(--color-theme-red) !important;
  border: 1px solid var(--color-theme-red) !important;
}

.CaseTemplateRow_button_create__gHgPe {
  width: 200px;
  margin-left: 15px !important;
  color: var(--color-theme-red) !important;
  border: 1px solid var(--color-theme-red) !important;
  color: var(--color-theme-red) !important;
  border: 1px solid var(--color-theme-red) !important;
}

.CaseTemplateRow_deletionPopupButtonContainer__-rknP {
  display: flex;
  margin-top: 36px;
  flex-direction: row-reverse;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/CaseTemplateRow/CaseTemplateRow.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,SAAS;EACT,YAAY;AACd;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;;EAEZ,+CAA+C;EAC/C,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,qDAAqD;EACrD,qDAAqD;EACrD,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;EAC/C,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,4BAA4B;;EAE5B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;;EAEZ,+CAA+C;EAC/C,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,qDAAqD;EACrD,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,wDAAwD;EACxD,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,4BAA4B;EAC5B,wCAAwC;EACxC,mDAAmD;EACnD,wCAAwC;EACxC,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,wCAAwC;EACxC,mDAAmD;EACnD,wCAAwC;EACxC,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B","sourcesContent":[".edit_popup {\n  z-index: 8000;\n}\n\n.edit_popup_container {\n  position: fixed !important;\n  left: 210px;\n  top: 91px;\n  width: 290px;\n}\n\n/* email row */\n.email_row_root {\n  margin-top: 10px;\n  display: flex;\n  color: var(--color-theme-10);\n  height: 45px;\n  cursor: pointer;\n  align-items: center;\n  padding: 5px;\n\n  background-color: var(--color-bg-caselist-item);\n  border: 2px solid var(--color-bg-caselist-item);\n}\n\n.email_row_root:hover {\n  background-color: var(--color-bg-caselist-item-hover);\n  border: 2px solid var(--color-bg-caselist-item-hover);\n}\n\n.root_inactive {\n  background-color: var(--color-bg-caselist-item);\n  border: 1px solid var(--color-theme-bright-gray);\n}\n\n.root_active {\n  background-color: var(--color-bg-caselist-item-hover);\n  border: 2px solid var(--color-bg-caselist-item-hover);\n  box-shadow: 2px 2px 3px var(--color-theme-cloud);\n}\n\n.email_flow_input {\n  background-color: var(--color-bg-caselist-item);\n  outline: none;\n  border: none;\n  color: var(--color-font-10);\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.account_tree_icon {\n  margin: 0px 10px;\n}\n\n.edit_icon_container {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.edit_icon {\n  padding: 0px 10px;\n}\n\n.edit_icon:hover {\n  color: var(--color-font-10);\n}\n\n.input_container {\n  width: 65%;\n  margin-left: 30px;\n}\n\n.flow_list_item {\n  padding: 0px !important;\n}\n\n.email_row_root:hover .edit_icon {\n  color: var(--color-font-10);\n}\n\n/* submenu */\n.template_row_root {\n  display: flex;\n  color: var(--color-theme-10);\n\n  height: 45px;\n  cursor: pointer;\n  align-items: center;\n  padding: 5px;\n\n  background-color: var(--color-bg-caselist-item);\n  border: 2px solid var(--color-bg-caselist-item);\n}\n\n.template_row_root:hover {\n  background-color: var(--color-bg-caselist-item-hover);\n  border: 2px solid var(--color-bg-caselist-item-hover);\n  color: var(--color-font-10) !important;\n}\n\n.template_row_root_selected {\n  display: flex;\n  color: var(--color-theme-10);\n  height: 45px;\n  cursor: pointer;\n  align-items: center;\n  padding: 5px;\n  background-color: var(--color-bg-caselist-item-selected);\n  border: 2px solid var(--color-bg-caselist-item-selected);\n}\n\n.status_item {\n  height: 45px;\n  font-size: 12px;\n}\n\n.status_icon {\n  margin: 0px 10px 0px 15px;\n}\n\n.status_icon svg {\n  font-size: 20px !important;\n}\n\n.status_title {\n  font-size: 13px;\n  display: inline-block;\n  height: 18px;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n\n.delete_template {\n  width: 100%;\n  display: none;\n  justify-content: flex-end;\n  color: var(--color-theme-cloud);\n}\n\n.add_template_title {\n  color: var(--color-theme-silver);\n}\n\n.add_template_icon {\n  color: var(--color-theme-silver);\n}\n\n.template_row_root:hover .add_template_icon {\n  color: var(--color-font-10);\n}\n\n.template_row_root:hover .add_template_title {\n  color: var(--color-font-10);\n}\n\n.template_row_root:hover .delete_template {\n  display: flex;\n  color: var(--color-theme-cloud);\n}\n\n.template_row_root_selected .delete_template {\n  display: flex;\n  color: var(--color-theme-cloud);\n}\n\n.delete_icon:hover {\n  color: var(--color-theme-blue);\n}\n\n.deletionPopupText {\n  padding: 5px;\n}\n\n.button_confirm {\n  font-weight: bold !important;\n  width: 100px;\n  margin-left: 15px !important;\n  color: var(--color-theme-red) !important;\n  border: 1px solid var(--color-theme-red) !important;\n  color: var(--color-theme-red) !important;\n  border: 1px solid var(--color-theme-red) !important;\n}\n\n.button_create {\n  width: 200px;\n  margin-left: 15px !important;\n  color: var(--color-theme-red) !important;\n  border: 1px solid var(--color-theme-red) !important;\n  color: var(--color-theme-red) !important;\n  border: 1px solid var(--color-theme-red) !important;\n}\n\n.deletionPopupButtonContainer {\n  display: flex;\n  margin-top: 36px;\n  flex-direction: row-reverse;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"edit_popup": `CaseTemplateRow_edit_popup__sCRdE`,
	"edit_popup_container": `CaseTemplateRow_edit_popup_container__LRFst`,
	"email_row_root": `CaseTemplateRow_email_row_root__0+mf4`,
	"root_inactive": `CaseTemplateRow_root_inactive__2k8-9`,
	"root_active": `CaseTemplateRow_root_active__2e-Dj`,
	"email_flow_input": `CaseTemplateRow_email_flow_input__bn-8A`,
	"account_tree_icon": `CaseTemplateRow_account_tree_icon__rStr6`,
	"edit_icon_container": `CaseTemplateRow_edit_icon_container__lMPMO`,
	"edit_icon": `CaseTemplateRow_edit_icon__pWFYo`,
	"input_container": `CaseTemplateRow_input_container__e2S7s`,
	"flow_list_item": `CaseTemplateRow_flow_list_item__RMBNm`,
	"template_row_root": `CaseTemplateRow_template_row_root__7zQin`,
	"template_row_root_selected": `CaseTemplateRow_template_row_root_selected__H6DlO`,
	"status_item": `CaseTemplateRow_status_item__kb14D`,
	"status_icon": `CaseTemplateRow_status_icon__s-EBn`,
	"status_title": `CaseTemplateRow_status_title__yzaGe`,
	"delete_template": `CaseTemplateRow_delete_template__N70Mk`,
	"add_template_title": `CaseTemplateRow_add_template_title__dzN5p`,
	"add_template_icon": `CaseTemplateRow_add_template_icon__zCwqA`,
	"delete_icon": `CaseTemplateRow_delete_icon__P-wcI`,
	"deletionPopupText": `CaseTemplateRow_deletionPopupText__gfHS4`,
	"button_confirm": `CaseTemplateRow_button_confirm__0zlLH`,
	"button_create": `CaseTemplateRow_button_create__gHgPe`,
	"deletionPopupButtonContainer": `CaseTemplateRow_deletionPopupButtonContainer__-rknP`
};
export default ___CSS_LOADER_EXPORT___;
